<template>
	<div class="flex items-center justify-center gap-2">
		<div
			v-tooltip="{ content: 'Edit margins', placement: 'bottom' }"
			class="flex-center size-6 cursor-pointer rounded bg-won-sand-light hover:bg-won-gray-light"
			@click="showEditMarginsHandler"
		>
			<ViewColumnsIcon
				class="size-[20px] text-won-dark"
			/>
		</div>
	</div>

	<EditMarginsModal
		:show-modal="showEditMargins"
		:close-modal="closeEditMarginsHandler"
	/>
</template>

<script setup>
import { ref } from 'vue';

import { ViewColumnsIcon } from '@heroicons/vue/24/outline';
import EditMarginsModal from '../../../../modals/editor/edit-margins.vue';


const showEditMargins = ref(false);

const showEditMarginsHandler = () => {
	showEditMargins.value = true;
};
const closeEditMarginsHandler = () => {
	showEditMargins.value = false;
};
</script>
